import { Attachment, RuleProps } from 'types/application';
import { FVG_DOWNLOAD } from '../VideoGames/classificationOfVideoGames';

export const PENDING_KDM = 'pending-kdm';

export const FILMS_PENDING_KDM = [
    {
        title: 'Films',
        steps: [],
        caseType: 'IMDA-FVGCS-Work-FVG-FilmTitles',
        forms: [
            {
                formID: 'submissionOfPendingKDM',
                title: '',
                fieldIDTitle: '',
                multiple: true,
                fields: [
                    {
                        sectionID: PENDING_KDM,
                        sectionName: '',
                        fieldList: [
                            {
                                id: 'attachments',
                                label: 'Upload KDM',
                                type: 'file',
                                category: 'SupportingDocuments',
                                span: 12,
                                fileTypes: ['.xml'],
                                mimeTypes: ['text/xml'],
                                rule: {
                                    baseIds: [`${PENDING_KDM}-link-to-attachments`],
                                    customValidate: ({ currentValue, baseValues }: RuleProps) => {
                                        const invalid = 'Required one of the following: Attachment, or Link';

                                        if (!baseValues) return invalid;

                                        const link = Boolean(baseValues[`${PENDING_KDM}-link-to-attachments`]);

                                        const attachments = Array.isArray(currentValue)
                                            ? (currentValue as Attachment[]).filter((attachment) => !attachment.deleted)
                                            : [];

                                        return link || attachments.length ? true : invalid;
                                    },
                                    revalidate: [`${PENDING_KDM}-link-to-attachments`]
                                }
                            },
                            {
                                id: 'link-to-attachments',
                                label: 'Upload Link to KDM',
                                type: 'url',
                                labelNote:
                                    'For files greater than 10MB or in a different file type, you may provide a link. e.g. Dropbox, GoogleDrive.',
                                rule: {
                                    baseIds: [`${PENDING_KDM}-attachments`],
                                    customValidate: ({ currentValue, baseValues }: RuleProps) => {
                                        const invalid = 'Required one of the following: Attachment, or Link';

                                        if (!baseValues) return invalid;

                                        const link = Boolean(currentValue);

                                        const attachmentsList = baseValues[`${PENDING_KDM}-attachments`];
                                        const attachments = Array.isArray(attachmentsList)
                                            ? (attachmentsList as Attachment[]).filter((attachment) => !attachment?.deleted)
                                            : [];

                                        return link || attachments.length > 0 ? true : invalid;
                                    },
                                    revalidate: [`${PENDING_KDM}-attachments`]
                                },
                                span: 6
                            },
                            {
                                id: 'remarks',
                                label: 'Remarks',
                                type: 'longText',
                                textRows: 4,
                                span: 12
                            }
                        ]
                    }
                ]
            },
            {
                formID: 'download',
                title: '',
                fields: FVG_DOWNLOAD
            }
        ]
    }
];

export const RCA_PENDING_KDM = [
    {
        title: 'Films',
        steps: [],
        caseType: 'IMDA-FVGCS-Work-FVG-RCAFlow',
        forms: [
            {
                formID: 'submissionOfPendingKDM',
                title: '',
                fieldIDTitle: '',
                multiple: true,
                fields: [
                    {
                        sectionID: PENDING_KDM,
                        sectionName: '',
                        fieldList: [
                            {
                                id: 'attachments',
                                label: 'Upload KDM',
                                type: 'file',
                                category: 'SupportingDocuments',
                                span: 12,
                                fileTypes: ['.xml'],
                                mimeTypes: ['text/xml'],
                                rule: {
                                    baseIds: [`${PENDING_KDM}-link-to-attachments`],
                                    customValidate: ({ currentValue, baseValues }: RuleProps) => {
                                        const invalid = 'Required one of the following: Attachment, or Link';

                                        if (!baseValues) return invalid;

                                        const link = Boolean(baseValues[`${PENDING_KDM}-link-to-attachments`]);

                                        const attachments = Array.isArray(currentValue)
                                            ? (currentValue as Attachment[]).filter((attachment) => !attachment.deleted)
                                            : [];

                                        return link || attachments.length ? true : invalid;
                                    },
                                    revalidate: [`${PENDING_KDM}-link-to-attachments`]
                                }
                            },
                            {
                                id: 'link-to-attachments',
                                label: 'Upload Link to KDM',
                                type: 'url',
                                labelNote:
                                    'For files greater than 10MB or in a different file type, you may provide a link. e.g. Dropbox, GoogleDrive.',
                                rule: {
                                    baseIds: [`${PENDING_KDM}-attachments`],
                                    customValidate: ({ currentValue, baseValues }: RuleProps) => {
                                        const invalid = 'Required one of the following: Attachment, or Link';

                                        if (!baseValues) return invalid;

                                        const link = Boolean(currentValue);

                                        const attachmentsList = baseValues[`${PENDING_KDM}-attachments`];
                                        const attachments = Array.isArray(attachmentsList)
                                            ? (attachmentsList as Attachment[]).filter((attachment) => !attachment?.deleted)
                                            : [];

                                        return link || attachments.length > 0 ? true : invalid;
                                    },
                                    revalidate: [`${PENDING_KDM}-attachments`]
                                },
                                span: 6
                            },
                            {
                                id: 'remarks',
                                label: 'Remarks',
                                type: 'longText',
                                textRows: 4,
                                span: 12
                            }
                        ]
                    }
                ]
            },
            {
                formID: 'download',
                title: '',
                fields: FVG_DOWNLOAD
            }
        ]
    }
];
